// extracted by mini-css-extract-plugin
export var actionButton = "_f8-0";
export var fileInput = "_f8-2";
export var paperclip = "_f8-1";